var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: { visible: _vm.show, width: "80%", "close-on-click-modal": false },
      on: {
        "update:visible": function($event) {
          _vm.show = $event
        }
      }
    },
    [
      _c(
        "el-table",
        { attrs: { data: _vm.list, heig: "700", "span-method": _vm.spanRows } },
        [
          _c("el-table-column", {
            attrs: { label: "代采计划", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", [
                      _c("div", [_vm._v(_vm._s(scope.row.planid))]),
                      _vm._v(" "),
                      _c("div", [_vm._v(_vm._s(scope.row.plan_type))]),
                      _vm._v(" "),
                      _c("div", [_vm._v(_vm._s(scope.row.create_time))]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: scope.row.is_off_goods,
                              expression: "scope.row.is_off_goods"
                            }
                          ]
                        },
                        [_vm._v("特价商品")]
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "整期改价", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("el-input", {
                      attrs: { size: "small" },
                      on: {
                        blur: function($event) {
                          return _vm.changePlanPrice(scope.row, scope.$index)
                        }
                      },
                      model: {
                        value: scope.row.new_plan_price,
                        callback: function($$v) {
                          _vm.$set(scope.row, "new_plan_price", $$v)
                        },
                        expression: "scope.row.new_plan_price"
                      }
                    })
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "SKU改价", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("el-input", {
                      attrs: { size: "small" },
                      on: {
                        blur: function($event) {
                          return _vm.changeSkuPrice(scope.row)
                        }
                      },
                      model: {
                        value: scope.row.new_sku_price,
                        callback: function($$v) {
                          _vm.$set(scope.row, "new_sku_price", $$v)
                        },
                        expression: "scope.row.new_sku_price"
                      }
                    })
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "商家价", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", [
                      _c("div", [
                        _vm._v(
                          "\n            " +
                            _vm._s(scope.row.plan_price) +
                            "\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: scope.row.remove_price,
                              expression: "scope.row.remove_price"
                            }
                          ]
                        },
                        [
                          _c("strike", [_vm._v(_vm._s(scope.row.remove_price))])
                        ],
                        1
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "颜色", prop: "co_val", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "尺码", prop: "si_val", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "选择开单", prop: "cg_num" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "剩余", prop: "left_num", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "前置数量", prop: "dk_num", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "小计", prop: "total", align: "center" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62acef88", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62acef88","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/purchaseverify/components/MultiPhaseGoods.vue
// module id = null
// module chunks = 